import { render, staticRenderFns } from "./BatchOrder.vue?vue&type=template&id=bbda01a4&scoped=true&"
import script from "./BatchOrder.vue?vue&type=script&lang=js&"
export * from "./BatchOrder.vue?vue&type=script&lang=js&"
import style0 from "./BatchOrder.vue?vue&type=style&index=0&id=bbda01a4&scoped=true&lang=scss&"
import style1 from "./BatchOrder.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bbda01a4",
  null
  
)

export default component.exports